module.exports = __webpack_public_path__ + "img/11.76cb38b2.jpg";